import {Injectable} from "@angular/core";
import {AddressModel, addressModelFactory} from "../address/address.model";
import {paramsToQueryString} from "../http/url-params-serializer";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {CreditCheckReportHistory, CreditCheckReportHistoryDataModelFactory, CreditCheckAnalyst, CreditCheckAnalystModelFactory } from "./credit-check.model";
import { PrivilegeViewService } from "../privilege-view/privilege-view.service";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class CreditCheckService {
  private url: string = "/api/CreditCheck";

  constructor(private http: HttpClient, private privilegeViewService: PrivilegeViewService) {}

  getCreditCheckRequestReport(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search: string,
    filterObj:any = '',
  ): Promise<{rows: CreditCheckReportHistory[], count: number,}> {
    let params = {
      page: `${page}`,
      limit: `${limit}`,
      search: `${search || ""}`,
      sequence: "true",
      domain: this.privilegeViewService.getDomainView(),
    };
    params = {...params, ...filterObj}

    return this.http.get<{rows: CreditCheckReportHistory[], count: number}>(`${this.url}`, {params})
      .pipe(
        map(
          ({rows, count}) =>
            ({rows: rows.map(row=>CreditCheckReportHistoryDataModelFactory(row)), count: +count}),
        ),
      )
      .toPromise();
  }

  creditCheckRequestRelease(selectedCreditCheckList): Promise<{releasedCreditCheckList}>{
    return this.http.post<{releasedCreditCheckList}>(`${this.url}`, {selectedCreditCheckList})
      .pipe(
        map(
          (releasedCreditCheckList) =>releasedCreditCheckList
        ),
      )
      .toPromise();
  }

  getCreditAnalyst(): Promise<{rows: CreditCheckAnalyst[]}> {
    let params = {
    };
    return this.http.get<{rows: CreditCheckAnalyst[]}>(`${this.url}/credit-analyst`, {params})
      .pipe(
        map(
          ({rows}) =>
            ({rows: rows.map(row=>CreditCheckAnalystModelFactory(row))}),
        ),
      )
      .toPromise();
  }
}
